export default {
  generic: "Qualcosa è andato storto. Riprova.",
  serverError: "Si è verificato un errore del server. Riprova.",
  network: "Errore di rete. Controlla la connessione e riprova.",
  validation: "Controlla i valori inviati e riprova.",
  loginFailed: "Accesso non riuscito",
  createActivity: "Errore nella creazione dell’attività",
  updateActivity: "Errore nell’aggiornamento dell’attività",
  activityActivationIncomplete:
    "Non puoi ancora attivare questa attività. Mancano: {{items}}.",
  activityActivationMissingDescription: "descrizione in tutte le lingue",
  activityActivationMissingPhotos: "almeno una foto",
  activityActivationMissingMenuItems: "voci di menu",
  activityActivationMissingServiceItems: "servizi o esperienze",
  activityActivationMissingAvailability: "almeno una fascia di disponibilità",
  updateServiceCategories:
    "Errore nell’aggiornamento delle categorie di servizio",
  changeProfileType: "Impossibile cambiare il tipo di profilo",
  saveProfile: "Errore nel salvataggio del profilo",
  loadDevicePresets: "Impossibile caricare i preset del dispositivo",
  savePreset: "Impossibile salvare il preset",
  deletePreset: "Impossibile eliminare il preset",
  createDevice: "Impossibile creare il dispositivo",
  deviceDuplicateSerialNumber:
    "Esiste già un dispositivo con questo numero di serie",
  deviceDuplicateSoftwareId:
    "La chiave software è già assegnata al dispositivo {{displayName}}",
  deviceDuplicateSoftwareIdUnknown:
    "La chiave software è già assegnata a un altro dispositivo",
  loadDevices: "Impossibile caricare i dispositivi",
  loadReaders: "Impossibile caricare i lettori",
  loadReaderPresets: "Impossibile caricare i preset dei lettori",
  updateDevice: "Impossibile aggiornare il dispositivo",
  regenerateCredentials: "Impossibile rigenerare le credenziali",
  assignDevice: "Impossibile assegnare il dispositivo",
  updateHouse: "Impossibile aggiornare la struttura",
  renameDevice: "Impossibile rinominare il dispositivo",
  reorderDevices: "Impossibile riordinare i dispositivi",
  loadHouses: "Impossibile caricare le strutture",
  loadHosts: "Impossibile caricare gli host",
  loadSalesAgents: "Impossibile caricare gli agenti di commercio",
  loadOwners: "Impossibile caricare venditori e host",
  loadSellers: "Impossibile caricare i venditori",
  loadActivities: "Impossibile caricare le attività",
  loadRegions: "Impossibile caricare le regioni",
  createHouse: "Impossibile creare la struttura",
  createHost: "Impossibile creare l’host",
  readerOperation: "Operazione del lettore non riuscita",
  addPresence: "Impossibile registrare l’ospite",
  updatePresence: "Impossibile aggiornare l’ospite",
  deletePresence: "Impossibile eliminare l’ospite",
  createSalesAgent: "Impossibile creare l’agente di commercio",
  autoTranslateItem: "Traduzione automatica non riuscita. Riprova più tardi.",
  forgotPasswordFailed:
    "Impossibile inviare l’email di reset. Riprova più tardi.",
  setPasswordFailed:
    "Impossibile impostare la password. Riprova o richiedi un nuovo link.",
  amendReasonWrongStatus:
    "Questa prenotazione non può essere modificata nello stato attuale.",
  amendReasonRefunded:
    "Questa prenotazione è stata rimborsata e non può essere modificata.",
  amendReasonRefundRetrying: "Un rimborso è in corso; riprova più tardi.",
  amendReasonProviderBlocksAmendment:
    "Questa prenotazione è sincronizzata esternamente e non può essere modificata qui.",
  amendReasonMissingVisit: "Questa prenotazione non ha data/ora da modificare.",
  amendRequiresOverride:
    "Vincoli di capacità o scadenza richiedono un override esplicito.",
  impersonateUser: "Impossibile impersonare questo utente.",
} as const;
